import { Container, Title, Text, Paper, Button } from "@mantine/core";
import { Link } from "wouter";

export default function PaymentCancelled() {
  return (
    <Container mt="xl" size="sm" ta="center">
      <Paper p="xl" mt="xl">
        <Title ta="center">Payment Cancelled</Title>
        <Text mt="md">You have cancelled the payment. No charge was made.</Text>
        <Button mt="lg" component={Link} to="/">
          Continue
        </Button>
      </Paper>
    </Container>
  );
}
